import React from "react";
import withLanguageContext from "lib/hocs/withLanguageContext";
import { Typography } from "Components/Base/DataDisplay/Typography";
import {
  LearningActivityCard,
  LearningActivityListItem,
} from "Components/Module/LearningActivityItem";
import ActivityDescription from "Components/Module/LearningActivityItem/Description";
import { getCardImage } from "Components/Module/LearningActivityItem/functions";
import Rating from "lib/components/Rating";
import { LinearProgress } from "Components/Base/Feedback/LinearProgress";
import * as CONSTANTS from "domains/programs/constants";
import { useDisplayLearningActivityCardImage } from "lib/hocs/useLearningActivityCardState";
import { ProgramChips } from "./Chips";
import { COURSE_TYPE_PROGRAM } from "../../constants";
import { ProgramActions } from "./Actions";
import { useMyLearning } from "../../context";

const ProgramItem = ({
  program,
  programUrl,
  managerView,
  languageContext,
  onClick,
  updateRating,
}) => {
  const { listView } = useMyLearning();
  const withProgress = program.progress >= 0 && program.progress <= 100;
  const displayImage = useDisplayLearningActivityCardImage();
  const { imageComponent } = getCardImage(
    program,
    displayImage,
    false,
    listView ? "small" : "medium",
  );

  const ProramItemType = listView
    ? LearningActivityListItem
    : LearningActivityCard;

  return (
    <ProramItemType
      id={`learningActivityCard${program.courseId}`}
      title={program.title}
      type={COURSE_TYPE_PROGRAM}
      displayImage={displayImage}
      imageComponent={imageComponent}
      chips={
        <ProgramChips
          program={program}
          completed={program.completed}
          languageContext={languageContext}
        />
      }
      content={
        <>
          {program.activityTitle && (
            <Typography
              className="italic elipssis"
              variant="h4"
              title={program.activityTitle}
            >
              {program.activityTitle}
            </Typography>
          )}

          {program.allowRating && (
            <Rating
              currentRating={program.personalRating.rating}
              currentComment={program.personalRating.comment}
              type={5}
              objectId={program.courseId}
              updateRating={updateRating}
              readOnly={false}
              managerView={managerView}
            />
          )}
          <ActivityDescription
            description={program.description}
            maxLength={listView ? 10000 : 100}
          />
          {withProgress && (
            <LinearProgress
              id="programLinearProgress"
              value={program.progress}
              title={`${languageContext("completed2")}: ${program.progress}%`}
              colorOverride={CONSTANTS.COURSE_COLOR_PROGRESS_HIGH}
            />
          )}
        </>
      }
      actions={
        <ProgramActions
          program={program}
          managerView={managerView}
          onClick={onClick}
          programUrl={programUrl}
          languageContext={languageContext}
        />
      }
    />
  );
};

export default withLanguageContext(ProgramItem, "ActivityCentre");
